import axios from "axios";

import apiUrl from "../../api-url";

const STORE_MOUNT_POINT = "locationDetail";

// URLS
const SHIPMENTS_URL = apiUrl("/shipping-ng/shipments");

// actions
const RECEIVE_SEARCH_RESULT = "location-detail/RECEIVE_SEARCH_RESULT";
const RECEIVE_SHIPMENT = "location-detail/RECEIVE_SHIPMENT";
const CLEAR_LOCATION_SHIPMENTS = "location-detail/CLEAR_LOCATION_SHIPMENTS";

// fetchers and action creators
function fetchLocationShipments(locationId) {
  const url =
    SHIPMENTS_URL +
    "?page_number=0&page_size=200&shipper_location_ids=" +
    locationId;

  return dispatch => {
    return Promise.all([axios.get(`${url}`)])
      .then(responses => {
        dispatch({ type: RECEIVE_SEARCH_RESULT, payload: responses[0].data });
      })
      .catch(err => {
        //        throw new Error(err);
      });
  };
}

function clearLocationShipments() {
  return dispatch => {
    dispatch({ type: CLEAR_LOCATION_SHIPMENTS, payload: null });
  };
}

function fetchShipment(shipmentID) {
  const url = SHIPMENTS_URL + "/" + shipmentID;

  return dispatch => {
    return Promise.all([axios.get(`${url}`)])
      .then(responses => {
        dispatch({ type: RECEIVE_SHIPMENT, payload: responses[0].data });
      })
      .catch(err => {
        //throw new Error(err);
      });
  };
}

// initial state
const initialState = {
  shipmentSummaries: [],
  locationShipments: []
};

// selectors
const getLocationShipments = state => state.locationDetail.locationShipments;
const getShipmentSummaries = state => state.locationDetail.shipmentSummaries;

// reducer
const LocationDetailReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CLEAR_LOCATION_SHIPMENTS:
      return {
        ...state,
        shipmentSummaries: [],
        locationShipments: []
      };

    case RECEIVE_SEARCH_RESULT:
      return {
        ...state,
        shipmentSummaries: action.payload.data
      };

    case RECEIVE_SHIPMENT:
      const newShipment = [action.payload];
      return {
        ...state,
        locationShipments: newShipment.concat(state.locationShipments)
      };
    default:
      return state;
  }
};

// interface
const LocationDetailState = {
  mountPoint: STORE_MOUNT_POINT,
  actionTypes: {},
  actionCreators: {
    fetchLocationShipments,
    fetchShipment,
    clearLocationShipments
  },
  selectors: {
    getLocationShipments,
    getShipmentSummaries
  },
  reducer: LocationDetailReducer
};
export default LocationDetailState;



// WEBPACK FOOTER //
// ./src/modules/location-detail/LocationDetailState.js